import Vue from 'vue'
import VueRouter from 'vue-router'
import permission from './permission'

Vue.use(VueRouter)

const routes = [{
  path: '/login',
  component: () =>
    import('../views/login/index.vue'),
},
{
  path: '/account',
  title: '用户中心',
  component: () =>
    import('../views/index.vue'),
  children: [
    {
      path: '',
      name: 'user',
      component: () =>
        import('../views/user/info.vue'),
    },
    {
      path: 'setting_p',
      component: () =>
        import('../views/user/password.vue'),
    }]
},
{
  path: '/register',
  component: () =>
    import('../views/login/register.vue'),
},
{
  path: '/author',
  title: '创作者合作计划',
  component: () =>
    import('../views/author/index.vue'),
},
{
  path: '/author/apply',
  title: '创作者合作计划',
  name: 'author_apply',
  component: () =>
    import('../views/author/apply.vue'),
},
{
  path: '/404',
  title: '404页面',
  component: () =>
    import('../views/common/404.vue'),
},
{
  path: '/article/preview',
  component: () =>
    import('../views/article/info.vue')
},
{
  path: '/share',
  title: '文章分享预览页',
  component: () =>
    import('../views/article/share.vue')
},
{
  path: '/',
  component: () =>
    import('../views/index.vue'),
  meta: {
    auth: true
  },
  children: [
    {
      path: '',
      title: '首页',
      component: () =>
        import('../views/home/index.vue')
    },
    {
      path: '/article',
      title: '我的文章',
      component: () =>
        import('../views/article/index.vue'),
      children: [
        {
          path: '',
          component: () =>
            import('../views/article/list.vue'),
        }]
    },
    {
      path: '/article/create',
      name: 'Create',
      component: () =>
        import('../views/article/create.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/material',
      title: '素材库',
      component: () =>
        import('../views/material/list.vue')
    },
    {
      path: '/comments/',
      title: '评论管理',
      component: () =>
        import('../views/comments/index.vue')
    },
    {
      path: '/notification',
      title: '消息通知',
      name: 'Notification',
      component: () =>
        import('../views/notification/index.vue')
    },

    {
      path: '/agency',
      component: () =>
        import('../views/agency/index.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/used/create',
      component: () =>
        import('../views/used/create.vue'),
      meta: {
        auth: true
      }
    },
  ]
},
{
  path: '/h5maker/',
  component: () =>
    import('../views/h5maker/index.vue'),
  meta: {
    auth: true
  },
  children: [
    {
      path: '',
      component: () => import('../views/index.vue'),
      children: [
        {
          path: 'home',
          name: 'h5makerHome',
          component: () => import('../views/h5maker/home.vue')
        },
        {
          path: 'all',
          name: 'h5makerAll',
          component: () => import('../views/h5maker/all.vue')
        },
        {
          path: 'share/:id',
          name: 'h5makerShare',
          component: () => import('../views/h5maker/share.vue')
        },
        {
          path: 'statistics/:id',
          name: 'h5makerStatistics',
          component: () => import('../views/h5maker/statistics.vue')
        },
      ]
    },
    {
      path: '/h5maker/create',
      name: 'h5makerCreate',
      component: () =>
        import('../views/h5maker/create.vue'),
    },
    {
      path: '/h5maker/edit/:id',
      name: 'h5makerEdit',
      component: () =>
        import('../views/h5maker/edit.vue'),
    },
  ]
  },

  {
    path: '/exhibition',
    component: () =>
      import('../views/exhibition/index.vue'),
    meta: {
      auth: true
    },
    children: [
      {
        path: 'sel-location/',
        title: '选择展位',
        component: () =>
          import('../views/exhibition/sel-location.vue')
      },
      {
        path: 'location-order/',
        title: '展位订单',
        component: () =>
          import('../views/exhibition/order.vue')
      },
    ]
  },


// 商城模块
{
  path: '/mall',
  component: () =>
    import('../views/index.vue'),
  meta: {
    auth: true
  },
  children: [
    {
      path: '/',
      title: '店铺',
      component: () =>
        import('../views/mall/index.vue')
    },
    {
      path: 'items/',
      title: '商品',
      component: () =>
        import('../views/mall/items.vue')
    },
    {
      path: 'orders/',
      title: '订单',
      component: () =>
        import('../views/mall/orders.vue')
    },
    {
      path: 'customers/',
      title: '客户',
      component: () =>
        import('../views/mall/customers.vue')
    },
    {
      path: 'settings/',
      title: '设置',
      component: () =>
        import('../views/mall/settings.vue')
    },
  ]
},
{
  path: '/article/:id',
  name: 'Publish',
  component: () =>
    import('../views/publish/index.vue'),
  meta: {
    auth: true
  }
},
{
  path: '/article/:id/jump',
  name: 'PublishJump',
  component: () =>
    import('../views/publish/jump.vue'),
  meta: {
    auth: true
  }
},
{
  path: '/article/:id/setting',
  name: 'article_setting',
  component: () =>
    import('../views/publish/settings.vue'),
  meta: {
    auth: true
  }
},
{
  path: '/test',
  component: () =>
    import('../views/test/editor.vue'),
  meta: {
    auth: true
  }
},
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// Before Router Enter
router.beforeEach((to, from, next) => {

  // 是否需要登录
  const requireAuth = to.matched.some((r) => r.meta.auth)
  // 是否已登录
  const isLoggedin = permission.auth()
  if (requireAuth && !isLoggedin) {
    // 当前连接
    // const from = encodeURIComponent(window.location.href);
    // // // 跳转
    // window.location.replace(`https://account.21rv.com/auth?from=${from}`);
    next({
      path: '/login',
      query: { from: to.fullPath }
    })
  } else {
    if (to.matched.length === 0) {
      next()
      // next('/404') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
    } else {
      next()
    }
  }
})


export default router